import useDataLayer from '@/hooks/useDataLayer/useDataLayer';
import useEpilot from '@/hooks/useEpilot/useEpilot';
import Stack from '@uikit/components/Stack/Stack';
import clsx from 'clsx';
import { MouseEventHandler } from 'react';
import { Headline } from '../Headline/Headline';
import { Text } from '../Text/Text';
import styles from './Contact.module.scss';

export const Contact = () => {
  const { pushDataLayerEvent } = useDataLayer();
  const { showJourney } = useEpilot();

  const headlineText = 'Sieht aus, als sollten wir uns unterhalten!';

  const pushCustomClick: MouseEventHandler<HTMLElement> = (event) => {
    pushDataLayerEvent({
      event: 'customClick',
      clickContext: headlineText,
      customClickText: event.currentTarget.innerText,
      customPagePath: window.location.pathname,
    });
  };

  const handleJourneyClick =
    (journeyId: string): MouseEventHandler<HTMLButtonElement> =>
    (event) => {
      pushCustomClick(event);
      showJourney(journeyId);
    };

  return (
    <div className={styles.base}>
      <Headline level={2}>{headlineText}</Headline>

      <Text className={styles.subtitle} align="center">
        Steigen Sie mit uns in die Elektromobilität ein.
      </Text>

      <Stack
        flexDirection={{ initial: 'column', sm: 'row' }}
        gap={{ initial: '1rem', md: '1rem' }}
        justifyContent="center"
        alignItems="center"
      >
        <button
          className={styles.button}
          onClick={handleJourneyClick('fe289e30-3daf-11ee-8299-a971753aa401')}
          type="button"
        >
          Formular für Neukunden
        </button>

        <button
          className={clsx(styles.button, styles.isOutlined)}
          onClick={handleJourneyClick('2d4c67f0-2bae-11ee-bd7a-2361d349416c')}
          type="button"
        >
          Formular für Bestandskunden
        </button>
      </Stack>

      <Text className={styles.phoneText} align="center">
        <strong>Oder rufen Sie uns an</strong>
      </Text>

      <a
        className={styles.phone}
        href="tel:+495114303113"
        onClick={pushCustomClick}
      >
        0511.430.3113
      </a>
    </div>
  );
};
